import React, { Suspense, lazy } from 'react';

const Spline = lazy(() => import('@splinetool/react-spline'));

const SplineScene = () => {
  return (
    <div className="spline-container">
      <Suspense fallback={
        <div className="spline-loader">
          <div className="loader-pulse"></div>
        </div>
      }>
        <Spline scene="https://prod.spline.design/NbVmy6DPLhY-5Lvg/scene.splinecode" />
      </Suspense>
    </div>
  );
};

export default SplineScene;
